import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const CryptoPieChart = ({
	data,
	windowWidth,
	activeIndex,
	handlePieClick,
	renderActiveShape,
}) => {
	const innerRadius = windowWidth <= 768 ? 80 : 100
	const outerRadius = windowWidth <= 768 ? 120 : 150

	return (
		<ResponsiveContainer width='100%' height={windowWidth <= 768 ? 300 : 400}>
			<PieChart
				width={windowWidth <= 768 ? 300 : 400}
				height={windowWidth <= 768 ? 300 : 400}
			>
				<Pie
					activeIndex={activeIndex}
					activeShape={renderActiveShape}
					data={data}
					cx='50%'
					cy='50%'
					innerRadius={innerRadius}
					outerRadius={outerRadius}
					paddingAngle={5}
					fill='#fffff'
					dataKey='value'
					onClick={handlePieClick}
					label={
						windowWidth > 765 ? ({ name, value }) => `${name} ${value}%` : null
					}
				>
					{data.map((crypto, index) => (
						<Cell key={`cell-${index}`} fill={crypto.color} />
					))}
				</Pie>
			</PieChart>
		</ResponsiveContainer>
	)
}

export default CryptoPieChart;
